const runtimeHost = typeof window !== "undefined" ? window.location.hostname : "";
const defaultSiteUrl = runtimeHost === "optisiteseo.com" ? "https://optisiteseo.com" : "https://dev.optisiteseo.com";

export const SITE_URL = (process.env.REACT_APP_SITE_URL || defaultSiteUrl).replace(/\/$/, "");

export function canonicalUrl(path = "/") {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return normalizedPath === "/" ? `${SITE_URL}/` : `${SITE_URL}${normalizedPath}`;
}
